import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

export interface WaveformBar {
  h: number;
  opacity: number;
}

/**
 * Reusable card: image (with optional badge) + audio strip (play, title, waveform, duration).
 * Used on signup and other auth/marketing screens.
 */
@Component({
  selector: 'om-memory-preview-card',
  imports: [],
  templateUrl: './memory-preview-card.html',
  styleUrl: './memory-preview-card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemoryPreviewCard {
  imageUrl = input.required<string>();
  imageAlt = input<string>('');
  /** e.g. "1 Año, 6 Meses" */
  badgeText = input<string>();
  audioTitle = input.required<string>();
  audioDuration = input.required<string>();
  waveformBars = input.required<WaveformBar[]>();

  playClicked = output<void>();

  onPlay(): void {
    this.playClicked.emit();
  }
}
